import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-empresa-edit',
  templateUrl: './empresa-edit.component.html',
  styleUrl: './empresa-edit.component.css',
  standalone: false
})
export class EmpresaEditComponent implements OnInit {

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("empresa").subscribe((data) => {
      this.fields = data;
    });
  }
  public readonly serviceApi = environment.apiUrl + '/v1/empresas';

  public readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Cadastros' }, { label: 'Empresas', link: '/empresa' }, { label: 'Edição' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
    save: 'empresa',
    // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
}
